import axios from 'axios'
import { createApp } from 'vue'
import { Customer } from '~/js/models/customer'
import {
  ERROR_MESSAGE_CUSTOMER_NOT_FOUND,
  ERROR_MESSAGE_EMAIL_FORMAT,
  ERROR_MESSAGE_EMAIL_ALREADY_REGISTERED,
  ERROR_MESSAGE_UNEXPECTED,
} from '~/js/constants/errorMessages'

const ID_CUSTOMER_ACCOUNT_EMAILADDRESS = 'js-customer-account-emailaddress'
document.addEventListener('DOMContentLoaded', () => {
  const elementCustomerAccountEmailaddress = document.getElementById(
    ID_CUSTOMER_ACCOUNT_EMAILADDRESS
  )
  if (!elementCustomerAccountEmailaddress) return

  const { baseUrl, customerId, emailCurrent, hashedCustomerId, returnTo } =
    elementCustomerAccountEmailaddress.dataset
  createApp({
    name: 'TemplatesCustomersAccountEmailaddress',
    data() {
      return {
        email: '',
        errorMessage: '',
        isProcessing: false,
      }
    },
    methods: {
      async onSubmit() {
        this.errorMessage = Customer.getNewEmailError(this.email, emailCurrent)
        if (this.errorMessage) return

        this.isProcessing = true
        try {
          await axios.post(`${baseUrl}/customers/change_email/apply`, {
            newEmailAddress: this.email,
            customerId,
            h: hashedCustomerId,
          })
          window.location = returnTo
        } catch (error) {
          this.isProcessing = false
          const message = error.response && error.response.data.result

          switch (message) {
            case 'Invalid email address format':
              this.errorMessage = ERROR_MESSAGE_EMAIL_FORMAT
              break
            case 'Email address is already registered':
              this.errorMessage = ERROR_MESSAGE_EMAIL_ALREADY_REGISTERED
              break
            case 'Customer information not found':
              this.errorMessage = ERROR_MESSAGE_CUSTOMER_NOT_FOUND
              break
            default:
              this.errorMessage = ERROR_MESSAGE_UNEXPECTED
          }
          console.error(error)
        }
      },
    },
  }).mount(elementCustomerAccountEmailaddress)
})
